import { AfterViewInit, Component, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { ResizedEvent } from 'angular-resize-event';
import { DEFAULT_THEME as defaultTheme } from '@nebular/theme';
import { Social_Platform,
  Material_Design_Red, 
  Material_Design_Pink, 
  Material_Design_Purple, 
  Material_Design_Deep_Purple } from '../config/color-palettes';

@Component({
  selector: 'nbx-stack-echart',
  templateUrl: './stackchart.component.html',
  styleUrls: ['./stackchart.component.scss']
})
export class StackEchartComponent implements AfterViewInit, OnChanges {
  themeSubscription: any;
  @Input() resizable: boolean = true;
  autoResize = true;

  width: number;
  height: number;
  defaultThemeVariables = defaultTheme.variables;
  @Input() tooltipstr: string = '';
  @Input() legendstr: string = '';
  @Input() seriesstr: string = '';
  @Input() titlestr: string = '';
  @Input() gridstr: string = '';
  @Input() xaxistr: string = '';
  @Input() yaxisstr: string = '';

  options: any = {};
  title: any;
  tooltip: any;
  legend: any;
  series: any;
  grid: any;
  xaxis: any;
  yaxis: any;

  onResized(event: ResizedEvent) {
    this.width = event.newWidth;
    console.log(event.newHeight);
    this.height = event.newHeight;
  }

  ngAfterViewInit() {

    //set defaults 
    this.tooltip= (this.tooltipstr == '') ?  {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          color: this.defaultThemeVariables.fgText,
          backgroundColor: this.defaultThemeVariables.tooltipBackgroundColor,
        },
      },
    } : JSON.parse(this.tooltipstr);

    this.legend = (this.legendstr == '') ? {
      orient: "horizontal", 
      data: ['Mail marketing', 'Affiliate advertising', 'Video ad', 'Direct interview', 'Search engine', 'Data'],
      textStyle: {
        color: this.defaultThemeVariables.fgText,
      },
    } : JSON.parse(this.legendstr);

    this.grid = (this.gridstr == '') ? {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    } : JSON.parse(this.gridstr);

    this.xaxis = (this.xaxistr == '') ? [
      {
        type: 'category',
        boundaryGap: false,
        data: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        axisTick: {
          alignWithLabel: true,
        },
        axisLine: {
          lineStyle: {
            color: this.defaultThemeVariables.axisLineColor,
          },
        },
        axisLabel: {
          textStyle: {
            color: this.defaultThemeVariables.fgText,
          },
        },
      },
    ] : JSON.parse(this.xaxistr);

    this.yaxis = (this.yaxisstr == '') ? [
      {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: this.defaultThemeVariables.axisLineColor,
          },
        },
        splitLine: {
          lineStyle: {
            color: this.defaultThemeVariables.splitLineColor,
          },
        },
        axisLabel: {
          textStyle: {
            color: this.defaultThemeVariables.fgText,
          },
        },
      },
    ] : JSON.parse(this.yaxisstr);

    this.series = (this.seriesstr == '') ? [
      {
        name: 'Mail marketing',
        type: 'line',
        stack: 'Total amount',
        data: [120, 132, 101, 134, 90, 230, 210],
      },
      {
        name: 'Affiliate advertising',
        type: 'line',
        stack: 'Total amount',
        data: [220, 182, 191, 234, 290, 330, 310],
      },
      {
        name: 'Video ad',
        type: 'line',
        stack: 'Total amount',
        data: [150, 232, 201, 154, 190, 330, 410],
      },
      {
        name: 'Direct interview',
        type: 'line',
        stack: 'Total amount',
        data: [320, 332, 301, 334, 390, 330, 320],
      },
      {
        name: 'Search engine',
        type: 'line',
        stack: 'Total amount',
        data: [820, 932, 901, 934, 1290, 1330, 1320],
      },
      {
        name: 'Data',
        type: 'line',
        stack: 'Total amount',
        data: [125, 130, 100, 130, 95, 230, 210],
      },
    ] : JSON.parse(this.seriesstr);

      this.options = {
        backgroundColor: "transparent",
        color: Object.values(Material_Design_Purple),
        tooltip: this.tooltip,
        legend: this.legend,
        grid: this.grid,
        xAxis: this.xaxis,
        yAxis: this.yaxis,
        series: this.series
      };
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes)
    {
      if (changes.hasOwnProperty(propName))
      {
        switch(propName) {
          case 'tooltipstr': {
            console.log("tooltip update");
              this.updateOptions('tooltip',this.tooltipstr);
            break;     
          }
          case 'legendstr': {
            console.log("legend update");
              this.updateOptions('legend',this.legendstr);
            break;
          }
          case 'seriesstr': {
            console.log("series update");
              this.updateOptions('series',this.seriesstr);
            break;
          }
          case 'titlestr': {
            console.log("title update");
              this.updateOptions('title',this.titlestr);
            break;
          }
          case 'gridstr': {
            console.log("grid update");
              this.updateOptions('grid',this.titlestr);
            break;
          }
          case 'xaxistr': {
            console.log("xaxis update");
              this.updateOptions('xaxis',this.titlestr);
            break;
          }
          case 'yaxisstr': {
            console.log("yaxis update");
              this.updateOptions('yaxis',this.titlestr);
            break;
          }
        }
      }
    }

    this.options = {
      backgroundColor: 'transparent',
      color: Object.values(Material_Design_Pink),
      title: this.title,
      tooltip: this.tooltip,
      legend: this.legend,
      grid: this.grid,
      xAxis: this.xaxis,
      yAxis: this.yaxis,
      series: this.series
    }

  }

    private updateOptions(opt, value) {
      console.log(opt)
      console.log(value)
      this[opt] = JSON.parse(value);
      console.log(this.tooltip);

      this.options[opt] = this[opt];

      console.log(this.options);  
    }
}